import { http, onSuccess, onFail } from "./http";

export const requestGetReminders = (eventKey) =>
    http.get(`/api/cp/notifier/event/${eventKey}`).then(onSuccess, onFail);

export const requestCreateReminder = (emailMessageTemplate, payload) =>
    http
        .post(
            `/api/cp/notifier/email_message_template/${emailMessageTemplate}`,
            payload
        )
        .then(onSuccess, onFail);

export const requestGetReminder = (emailMessageTemplate) =>
    http
        .get(`/api/cp/notifier/email_message_template/${emailMessageTemplate}`)
        .then(onSuccess, onFail);

export const requestRemoveReminder = (reminderId) =>
    http.delete(`/api/cp/notifier/${reminderId}`).then(onSuccess, onFail);

export const requestGetRecepients = (reminderId) =>
    http
        .get(`/api/cp/notifier/${reminderId}/recipient`)
        .then(onSuccess, onFail);

export const requestAppendRecepients = (reminderId, payload) =>
    http
        .post(`/api/cp/notifier/${reminderId}/recipient`, payload)
        .then(onSuccess, onFail);

export const requestDeleteRecepient = (recipientId) =>
    http
        .delete(`/api/cp/notifier/recipient/${recipientId}`)
        .then(onSuccess, onFail);

export const requestSendReminder = (reminderId) =>
    http.get(`/api/cp/notifier/${reminderId}/send`).then(onSuccess, onFail);

export const requestUpdateRecepientParams = (reminderId, payload) =>
    http
        .post(
            `/api/cp/notifier/${reminderId}/recipient_source_parameters`,
            payload
        )
        .then(onSuccess, onFail);

export const requestUpdateReminder = (reminderId, payload) =>
    http.put(`/api/cp/notifier/${reminderId}`, payload).then(onSuccess, onFail);

export const requestGetStatistic = (notifier) =>
    http.get(`/api/cp/mail/click/statistic/${notifier}`)
        .then(onSuccess, onFail);

export const requestGetRecipientsStatistic = (notifier) =>
    http.get(`/api/cp/notifier/${notifier}/recipient/statistic`)
        .then(onSuccess, onFail);

export const requestGetRecipientParams = (reminderId) =>
    http
        .get(`/api/cp/notifier/${reminderId}/recipient_source_parameters`)
        .then(onSuccess, onFail);

export const requestCreateRecipientParams = (reminderId, payload) =>
    http
        .post(
            `/api/cp/notifier/${reminderId}/recipient_source_parameters`,
            payload
        )
        .then(onSuccess, onFail);

export const requestSendRecipientMail = (recipient) =>
    http.get(`/api/cp/notifier/recipient/${recipient}/send`)
        .then(onSuccess, onFail);
    

export const requestGetStreams = (eventPassword) =>
    http.get(`/api/cp/event/${eventPassword}/stream`).then(onSuccess, onFail);
